import debounce from 'lodash.debounce';

const AjaxSearch = function () {
        const searchInput = $('#product-search__phrase');
        const searchInputMobile = $('#product-search__phrase-mobile');
        const searchResultsWrapper = $('.search-results');
        const searchResultsMobileWrapper = $('.product-search--mobile .search-results');
        const searchResultsBox = $('.search-results__inner');
        const glass = $('.product-search__glass');
        const loader = $('.product-search__loader');


        let searchFor = '';

        let dropdownShowed = false;
        let searchBoxShowed = false;
        let searchBoxMobileShowed = false;



        const toggleShowHideSearchBox = ($type = 'hide', mobile = false) => {

            if (!searchBoxShowed && $type === 'show') {
                searchResultsWrapper.removeClass('hidden');
                searchBoxShowed = true;
            }

            if (searchBoxShowed && $type === 'hide') {
                searchResultsWrapper.addClass('hidden');
                searchBoxShowed = false;
            }

            if (!searchBoxMobileShowed && $type === 'show' && mobile) {
                searchResultsMobileWrapper.removeClass('hidden');
                searchBoxMobileShowed = true;
            }

            if (searchBoxMobileShowed && $type === 'hide' && mobile) {
                searchResultsMobileWrapper.addClass('hidden');
                searchBoxMobileShowed = false;
            }

        };


        $(document).on('click', e => {

            if (searchBoxShowed && !$(e.target.parentNode).is('.product-search__wrapper')) {
                toggleShowHideSearchBox('hide');
            }


        })



        searchInput.on('keyup input', debounce(() => {
            searchFor = searchInput.val();
            searchFor = searchFor.trim();
            searchFor = searchFor.replace(/<>\{\}\[\]\\\/]/gi, '');
            searchFor = searchFor.replace(/\s\s+/g, ' ');
            console.log(searchFor)
            if (searchFor.length >= 3) {
                ajaxCall();
            }
        }, 200));

        searchInputMobile.on('input', debounce(() => {
            searchFor = searchInputMobile.val();
            searchFor = searchFor.trim();
            searchFor = searchFor.replace(/<>\{\}\[\]\\\/]/gi, '');
            searchFor = searchFor.replace(/\s\s+/g, ' ');

            if (searchFor.length >= 3) {
                ajaxCall(true);
            } else {
                toggleShowHideSearchBox('hide', true);
            }
        }, 200));


        function ajaxCall(mobile = false) {
            $.ajax({
                url: mapi_ajax_data.ajaxUrl,
                type: 'POST',
                dataType: "json",
                data: {
                    action: 'search_products',
                    phrase: searchFor,
                },
                beforeSend: () => {
                    glass.addClass('hidden');
                    loader.removeClass('hidden');
                },
                success: (response) => {

                    let searchContent;

                    if (response.found_products[0].no_found) {
                        searchContent = `<div class="search-results__item py-2.5 px-4 lg:p-4 flex items-center">${response.found_products[0].title}</div>`;
                    } else {
                        searchContent = response.found_products.map(item => {
                            return `
                           <a href="${item.permalink}" class="search-results__item py-2.5 px-4 lg:p-4 flex items-center hover:bg-gray-50">
                                <div class="search-results__image flex justify-center mr-3">
                                    ${item.thumbnail}
                                </div>
                                <div class="search-results__content">
                                    <div class="font-semibold text-sm mb-2.5">${item.title}</div>
                                    <p class="price">
                                        ${item.price}
                                    </p>
                                </div>
                            </a>                        
                        `;
                        });
                    }

                    searchResultsBox.html(searchContent);
                    glass.removeClass('hidden');
                    loader.addClass('hidden');
                    toggleShowHideSearchBox('show', mobile);


                }
            })
        }


    }
;

export default AjaxSearch;